export const ERR = {
  METER_001: 'ERR-METER-001',
  METER_002: 'ERR-METER-002',
  OCR_PHOTO_001: 'ERR-OCR-PHOTO-001',
  AUTH_001: 'ERR-AUTH-001',
  NETWORK_001: 'ERR-NETWORK-001',
  VALIDATION_001: 'ERR-VALIDATION-001',
  IMPORT_001: 'ERR-IMPORT-001',
  IMPORT_002: 'ERR-IMPORT-002',
  IMPORT_003: 'ERR-IMPORT-003',
  STOCK_010: 'ERR-STOCK-010',
}
